import React from 'react';
import './NewTimeline.css';

const NewTimelineSection = () => {
  return (
    <div className="new-timeline-section">
      <div className="new-timeline-first-container">
        <div className="new-timeline-heading">
          <h2>Our Story</h2>
        </div>

        <div className="new-timeline-columns">
          <div className="new-timeline-text-column left">
            <div className="new-timeline-text-wrapper">
              <p className="new-timeline-year">Our Beginnings</p>
              <p>
                In 1991, David Lemeshow, a seasoned chemist with a passion for the pharmaceutical industry, founded Pharm-Rx Chemical Corporation. Armed with a Bachelor of Science degree in Chemistry and over a decade of experience in both technical and sales roles, David set out to create a company focused on quality and service. His vision and commitment to excellence laid the foundation for Pharm-Rx's growth, which has continued to flourish since its humble beginnings as a one-person operation.
              </p>
            </div>
          </div>

          <div className="new-timeline-image-column">
            <picture>
              <img
                className="new-timeline-image"
                src="https://st2.depositphotos.com/5565776/10460/i/950/depositphotos_104609870-stock-photo-purchasing-order-and-calculator.jpg"
                alt="Purchasing order and calculator"
                loading="lazy"
              />
            </picture>
          </div>
        </div>
      </div>

      <div className="new-timeline-container new-timeline-bg">
        <div className="new-timeline-columns">
          <div className="new-timeline-image-column">
            <picture>
              <img
                className="new-timeline-image"
                src="https://mcusercontent.com/b3b72a7d8d7f00a383a083fd9/images/b5109433-f746-780f-b4e8-8b391a564f8d.jpg"
                alt="Business growth"
                loading="lazy"
              />
            </picture>
          </div>

          <div className="new-timeline-text-column right">
            <div className="new-timeline-text-wrapper">
              <p className="new-timeline-year">Our Climb</p>
              <p>
                Pharm-Rx’s growth didn’t come overnight. With a steadily growing product line and a reputation for reliability, we cultivated long-lasting relationships with clients and suppliers alike. Our journey has been driven by a shared dedication to delivering the finest ingredients, supported by a growing team that believes in the company’s mission.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="new-timeline-container">
        <div className="new-timeline-columns">
          <div className="new-timeline-text-column left">
            <div className="new-timeline-text-wrapper">
              <p className="new-timeline-year">Now</p>
              <p>
                Now, with a global presence and an extensive range of products, Pharm-Rx remains committed to delivering excellence in every ingredient. Our strong relationships with trusted suppliers allow us to offer exclusive partnerships and cutting-edge products that meet the demands of today’s market.
              </p>
            </div>
          </div>

          <div className="new-timeline-image-column">
            <picture>
              <img
                className="new-timeline-image"
                src="https://mcusercontent.com/b3b72a7d8d7f00a383a083fd9/images/f813e721-221f-c618-855d-1af9013d2426.jpg"
                alt="Research and development"
                loading="lazy"
              />
            </picture>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewTimelineSection;
